import { useSignPageControl } from '../use-sign-page-control';
import OrganizationSignUp from './OrganizationSignUp';
import ResetPassword from './ResetPassword';
import ResetPasswordConfirm from './ResetPasswordConfirm';

export type SignPageCode = (
  | 'resetpassword'
  | 'resetpasswordconfirm'
  | 'organization'
);

const SignPage = () => {
  const { pageCodePage } = useSignPageControl();

  return (
    <>
      {pageCodePage === 'resetpassword' && <ResetPassword />}
      {pageCodePage === 'resetpasswordconfirm' && <ResetPasswordConfirm />}
      {pageCodePage === 'organization' && <OrganizationSignUp />}
    </>
  );
};

export default SignPage;
